import React, { useState } from "react";
import CgFormCreator from "../common/CgFormCreator";
import PopupModal from "../common/PopupModal";
import OutsideClickHandler from "../common/OutsideClickHandler";
import CgRadioButton from "../common/CgRadioButton";


const TestCanvas = () => {
  const [isOpen, setOpen] = useState(false);
  const [error, setError] = useState(false);
  // const checkboxOption = {
  //   technologyDTO: [
  //     {
  //       code: "imaging_system",
  //       name: "3D Imaging System",
  //     },
  //     {
  //       code: "Air Abrasion",
  //       name: "Air Abrasion",
  //     },
  //     {
  //       code: "Cad-Cam",
  //       name: "CEREC/In-Office Crowns",
  //     },
  //     {
  //       code: "computer_controlled_anesthesia",
  //       name: "Computer-Controlled Anesthesia",
  //     },
  //     {
  //       code: "ct_scanner",
  //       name: "CT Scanner",
  //     },
  //     {
  //       code: "Digital X-Rays",
  //       name: "Digital X-Rays",
  //     },
  //     {
  //       code: "Intra-Oral Camera",
  //       name: "Intra-Oral Camera",
  //     },
  //     {
  //       code: "invisalign_clear_aligners",
  //       name: "Invisalign/Clear Aligners",
  //     },
  //     {
  //       code: "laser_cavity_detection",
  //       name: "Laser Cavity Detection",
  //     },
  //     {
  //       code: "panaramic_xrays",
  //       name: "Panoramic X-Rays",
  //     },
  //     {
  //       code: "Sedation Dentistry",
  //       name: "Sedation Dentistry",
  //     },
  //     {
  //       code: "Ultrasonic Scaling",
  //       name: "Ultrasonic Scaling",
  //     },
  //   ],
  // };

  const newSchema = [
    // {
    //   component: "checkbox",
    //   options: checkboxOption.technologyDTO,
    //   name: "newCheck",
    //   renderCustomError: error,
    //   customErrorMsg: error
    //     ? "Only one record can have contact type 'MAIN'"
    //     : "",
    //   keyValues: { label: "name", value: "code" },
    //   customRenderLabel: () => {
    //     return (
    //       <div>
    //         <h1> Heading</h1>
    //         <p> Something can be added</p>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   component: "input",
    //   type: "text",
    //   label: "Year",
    //   placeholder: "year",
    //   name: "year",

    //   //   defaultValue: "new",
    //   valueChangeCallback: () => {},
    //   required: true,
    //   // renderCustomError: error,
    //   // customErrorMsg: error
    //   //   ? "Only one record can have contact type 'MAIN'"
    //   //   : "",
    //   popupErrorMsg: error
    //     ? "Only one record can have contact type 'MAIN'"
    //     : "",
    // },
    // {
    //   component: "dropdown",
    //   label: "new test",
    //   dropdownOptions: [],
    //   name: "new",
    //   onSelectCallBack: () => {},
    //   renderCustomError: error,
    //   customErrorMsg: error
    //     ? "Only one record can have contact type 'MAIN'"
    //     : "",
    // },
    // {
    //   component: "input",
    //   type: "button",
    //   label: "Year",
    //   name: "year",
    //   defaultValue: "new",
    //   handleButtonClickCallback: (res) => {
    //     console.log(res);
    //   },
    //   btnClassName: "saveBtn",
    // },
    // {
    //   component: "radio",
    //   options: [],
    //   onSelect: () => {},
    //   renderCustomError: error,
    //   customErrorMsg: error
    //     ? "Only one record can have contact type 'MAIN'"
    //     : "",
    // },
    // {
    //   component: "custom",
    //   customRender: () => {
    //     return (
    //       <>
    //         <h1> welcome </h1>
    //         <div> new thing</div>
    //         <button> Text Button </button>
    //       </>
    //     );
    //   },
    // },
    // {
    //   component: "textarea",
    //   required: true,
    //   label: "NOTE",
    //   needBorder: false,
    //   onChangeCallBack: () => {},
    //   name: "new",
    //   renderCustomError: error,
    //   customErrorMsg: error
    //     ? "Only one record can have contact type 'MAIN'"
    //     : "",
    // },
    // {
    //   component: "input",
    //   type: "button",
    //   label: "Year",
    //   name: "year",
    //   defaultValue: "new",
    //   handleButtonClickCallback: (res) => {
    //     console.log(res);
    //     setError(!error);
    //   },
    //   btnClassName: "saveBtn",
    // },
    {
      component: "radio",
      options: [
        {
          code: "minimum",
          name: "Minimum",
          metadata: "min",
        },
        {
          code: "maximum",
          name: "Maximum",
          metadata: "max",
        },
      ],
      name: "minMax",
      keyValues: { label: "name", value: "code" },
      onSelect: (name, value, metaData) => {
        console.log("min max onselect", name, value, metaData);
      },
      renderCustomError: error,
      customErrorMsg: error
        ? "Only one record can have contact type 'MAIN'"
        : "",
    },
    {
      component: "radio",
      name: "gender",
      options: [
        {
          code: "male",
          name: "Male",
          metadata: "male",
        },
        {
          code: "female",
          name: "Female",
          metadata: "female",
        },
      ],
      keyValues: { label: "name", value: "code" },
      onSelect: (name, value, metaData) => {
        console.log("onSelect male felame", name, value, metaData);
      },
      renderCustomError: error,
      customErrorMsg: error
        ? "Only one record can have contact type 'MAIN'"
        : "",
    },
  ];

  const RenderDetails = () => {
    return (
      <>
        <CgFormCreator
          primaryButton="ADD"
          // noCancel
          schema={newSchema}
          onSubmitCallback={(val) => {
            console.log(val);
          }}
          onCancel={() => {
            setOpen(!isOpen);
          }}
        />
        <CgRadioButton
          keyValues={{ label: "name", value: "code" }}
          onSelect={(name, value, metaData) => {
            console.log("onSelect male felame", name, value, metaData);
          }}
          defaultValue={"Male"}
          options={[
            {
              code: "male",
              name: "Male",
              metadata: "male",
            },
            {
              code: "female",
              name: "Female",
              metadata: "female",
            },
          ]}
        />
        <CgRadioButton
          keyValues={{ label: "name", value: "code" }}
          onSelect={(name, value, metaData) => {
            console.log("onSelect male felame", name, value, metaData);
          }}
          defaultValue={"minimum"}
          options={[
            {
              code: "minimum",
              name: "Minimum",
              metadata: "min",
            },
            {
              code: "maximum",
              name: "Maximum",
              metadata: "max",
            },
          ]}
        />
      </>
    );
  };

  return (
    <>
      <OutsideClickHandler
        onClickOutside={() => {
          console.log("clicked outside");
        }}
      >
        <div>
          <button
            onClick={() => {
              setOpen(!isOpen);
              setError("")
            }}
          >
            CLick
          </button>
          <PopupModal
            isOpen={isOpen}
            width="60%"
            customRender={RenderDetails}
            onSave={() => {
              console.log(!isOpen);
            }}
            onClose={() => {
              setOpen(!isOpen);
            }}
          />
        </div>
      </OutsideClickHandler>
    </>
  );
};

export default TestCanvas;
